module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ws-panel"
  }, [_c('header', {
    staticClass: "ws-panel-heading ws-panel-heading-tabs"
  }, [_c('div', {
    staticClass: "el-tabs el-tabs--card"
  }, [_c('div', {
    staticClass: "el-tabs__header"
  }, [_c('div', {
    staticClass: "el-tabs__nav-wrap"
  }, [_c('div', {
    staticClass: "el-tabs__nav-scroll"
  }, [_c('div', {
    staticClass: "el-tabs__nav"
  }, _vm._l((_vm.tabItems), function(item) {
    return (item.show) ? _c('div', {
      staticClass: "el-tabs__item",
      class: {
        'is-active': _vm.activeView == item.name
      },
      on: {
        "click": function($event) {
          return _vm.tabClick(item)
        }
      }
    }, [_vm._v(_vm._s(item.tabName))]) : _vm._e()
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ws-panel-body"
  }, [_c('transition', [_c('keep-alive', [_c(_vm.activeView, {
    tag: "component",
    on: {
      "opentab": _vm.opentab,
      "closetab": _vm.closetab
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-1a99166c!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/tabpanel.vue
// module id = 301
// module chunks = 99 100